// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import YuqueFilledSvg from "@ant-design/icons-svg/es/asn/YuqueFilled";
import AntdIcon from '../components/AntdIcon';

var YuqueFilled = function YuqueFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: YuqueFilledSvg
  }));
};

YuqueFilled.displayName = 'YuqueFilled';
export default React.forwardRef(YuqueFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/YuqueFilled.js
// module id = 2083
// module chunks = 0